import { createContext } from 'react';
import { AppConfig } from '../../Utilities/config';

type ContextType = { config?: AppConfig };

const ConfigContext = createContext({} as ContextType);

export default ConfigContext;